import Select from 'antd/lib/select';
import React from 'react';
import { AppStoreAvailableBuild } from '../../../types';
import { antGrey, buildContainerStyle } from '../../styles/globalStyles';
import AppStoreBuildComponent from '../../appStoreBuilds/AppStoreBuildComponent';
import { SelectedAppStoreBuild } from './SelectedAppStoreBuild';

interface BuildSelectorComponentProps {
    appStoreSelectedBuilds: AppStoreAvailableBuild[];
    selectedBuild: AppStoreAvailableBuild;

    handleBuildSelect: (value: any) => void;
}

export const BuildSelectorComponent = (props: BuildSelectorComponentProps) => {
    const isMultiApk = props.appStoreSelectedBuilds?.length > 1;
    return (
        <div className="build-select-component" style={{ paddingRight: 20 }}>
            {isMultiApk ?
                <Select
                    defaultValue={[
                        <SelectedAppStoreBuild
                            key={props.appStoreSelectedBuilds[0].appStoreBuild.id}
                            build={props.appStoreSelectedBuilds[0]}
                        />,
                    ]}
                    bordered={false}
                    size={'small'}
                    showArrow={true}
                    onSelect={props.handleBuildSelect}
                    optionLabelProp="label"
                    style={{ backgroundColor: antGrey.grey4, borderRadius: 8 }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {props.appStoreSelectedBuilds.map((build, idx) => (
                        <Select.Option
                            key={idx}
                            value={build.appStoreBuild.id}
                            label={
                                <SelectedAppStoreBuild
                                    build={build}
                                    styleOverrides={{
                                        ...buildContainerStyle,
                                        fontWeight: 600,
                                    }}
                                />
                            }
                        >
                            <SelectedAppStoreBuild key={build.appStoreBuild.id} build={build} />
                        </Select.Option>
                    ))}
                </Select>
            :   <AppStoreBuildComponent
                    {...props.selectedBuild}
                    styleOverrides={{
                        backgroundColor: antGrey.grey4,
                    }}
                />
            }
        </div>
    );
};
